import { Color } from "../../domain";
import {
  ColorsRemoteDataSourceError,
  Endpoints,
  RemoteDataSource,
} from "../core";

export class ColorsRemoteDataSource extends RemoteDataSource {
  public async add(title: string, color: string): Promise<void> {
    try {
      await this.post(Endpoints.colors, { body: { title, color } });
    } catch (error) {
      if (!error.response) throw ColorsRemoteDataSourceError.networkError();
      throw ColorsRemoteDataSourceError.serverError();
    }
  }

  public async edit(
    id: string,
    info: { title?: string; color?: string }
  ): Promise<void> {
    try {
      const { color, title } = info;
      await this.patch(Endpoints.colors + `${id}/`, {
        body: {
          ...(title !== undefined ? { title } : {}),
          ...(color !== undefined ? { color } : {}),
        },
      });
    } catch (error) {
      if (!error.response) throw ColorsRemoteDataSourceError.networkError();
      throw ColorsRemoteDataSourceError.serverError();
    }
  }

  public async remove(id: string): Promise<void> {
    try {
      await this.delete(Endpoints.colors + `${id}/`);
    } catch (error) {
      if (!error.response) throw ColorsRemoteDataSourceError.networkError();
      throw ColorsRemoteDataSourceError.serverError();
    }
  }

  public async list(): Promise<Color[]> {
    try {
      const res = await this.get(Endpoints.colors);
      return res.data.map((json: any) => new Color().deserialize(json));
    } catch (error) {
      if (!error.response) throw ColorsRemoteDataSourceError.networkError();
      throw ColorsRemoteDataSourceError.serverError();
    }
  }
}
